export const  firebaseConfigTest = {
  apiKey: "AIzaSyDEhKDcjA4o3H-ZX82blWpay5fSYKMfRW8",
  authDomain: "loan-vidya.firebaseapp.com",
  projectId: "loan-vidya",
  storageBucket: "loan-vidya.appspot.com",
  messagingSenderId: "927944358529",
  appId: "1:927944358529:web:88eabd1bbe54348718ab80",
  measurementId: "G-XJZCEG1C39"
}